/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NormalAchievementType } from './NormalAchievementType';
export type FromNormalAchievement = {
    type: FromNormalAchievement.type;
    achievementType: NormalAchievementType;
    milestoneId: number;
};
export namespace FromNormalAchievement {
    export enum type {
        NORMAL_ACHIEVEMENT = 'normal_achievement',
    }
}

